import React from 'react';
import ContentManager from './ContentManager';
import { getInnovations, createInnovation, updateInnovation, deleteInnovation } from '../../api';

const Innovations = () => {
  const fields = [
    { name: 'title', label: 'Innovation Title', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea', rows: 3, required: true },
    { name: 'order', label: 'Display Order', type: 'number', defaultValue: 0 }
  ];

  return (
    <ContentManager
      title="Innovations Management"
      itemLabel="Innovation"
      fields={fields}
      fetchFn={getInnovations}
      createFn={createInnovation}
      updateFn={updateInnovation}
      deleteFn={deleteInnovation}
    />
  );
};

export default Innovations;
